import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { __ } from 'react-i18n';
import { NO_STOCK } from '../constants';

interface Props {
  onStock: number | string;
  unit: string;
  justify?: string;
  productInfo?: boolean;
  availability: string;
  orderAvailable: number;
}

function StockInfo({
  onStock,
  unit,
  justify = 'initial',
  productInfo = false,
  availability,
  orderAvailable,
}: Props) {
  const isAvailable = onStock > 0;
  const isOrderable = orderAvailable;
  const availabilityText =
    onStock > 0
      ? `${availability} ${onStock} ${unit}`
      : availability && availability !== 'Skladom'
      ? availability
      : NO_STOCK;

  return (
    <StockCount
      available={isAvailable}
      orderable={isOrderable ? true : false}
      justify={justify}
      productInfo={productInfo}
      availability={availability}
    >
      {(!availability || !isOrderable || isAvailable) && (
        <SvgIcon
          width={12}
          height={12}
          viewBox={isAvailable ? '2 2 12 12' : '0 0 12 12'}
          marginRight={productInfo ? 8 : 4}
          icon={isAvailable ? IconType.checked : IconType.x}
          fill={isAvailable ? 'black' : '#FF0000'}
          alt={isAvailable ? __('Skladom') : NO_STOCK}
          title={isAvailable ? __('Skladom') : NO_STOCK}
        />
      )}
      {availabilityText}{' '}
    </StockCount>
  );
}

const StockCount = styled.span<{
  available: boolean;
  justify: string;
  productInfo: boolean;
  orderable: boolean;
  availability: string;
}>`
  display: flex;
  align-items: center;
  font-size: ${rem(14)};
  color: ${({ available, orderable, availability }) =>
    available
      ? 'black'
      : orderable && availability !== 'Skladom'
      ? 'rgba(225, 201, 87, 1)'
      : '#FF0000'};
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: ${rem(18)};
  justify-content: ${({ justify }) => justify};
  margin: ${({ productInfo }) => (productInfo ? '0' : '0 auto')};
`;

export { StockInfo };
